import { render, staticRenderFns } from "./noOferta.vue?vue&type=template&id=18108f5e&"
import script from "./noOferta.vue?vue&type=script&lang=js&"
export * from "./noOferta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports